import type { ComponentProps } from 'react';
import { cx } from '../lib/cx';
import styles from './Button.module.css';

export const ButtonVariant = {
  Secondary: 'secondary',
  Primary: 'primary',
  Danger: 'danger',
  Ghost: 'ghost',
} as const;
export type ButtonVariant = (typeof ButtonVariant)[keyof typeof ButtonVariant];

interface ButtonProps extends ComponentProps<'button'> {
  readonly variant?: ButtonVariant;
}

export function Button({
  variant = ButtonVariant.Secondary,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  return <button type={type} className={cx(styles.button, styles[variant], className)} {...rest} />;
}
